import type { ExpandPluginOptions } from '@atlaskit/editor-plugin-expand';

export function expandPluginOptions(): ExpandPluginOptions {
	return {
		allowInsertion: true,
		useLongPressSelection: false,
		appearance: 'full-page',
		allowInteractiveExpand: true,
		__livePage: false,
	};
}
